if (!customElements.get('product-card-information')) {
  customElements.define(
    'product-card-information',
    class ProducCardInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        // this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-card-information:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      // initQuantityHandlers() {
      //   if (!this.quantityInput) return;

      //   this.quantityForm = this.querySelector('.product-form__quantity');
      //   if (!this.quantityForm) return;

      //   this.setQuantityBoundries();
      //   if (!this.dataset.originalSection) {
      //     this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      //   }
      // }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl; // f
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct; // f

        let selectedOptionId = target.dataset.variantIdValue;
        let selectedOptionPrice = target.dataset.variantPriceValue;
        let selectedOptionAvailable = target.dataset.variantAvailable;

        // console.log(66, selectedOptionId)

        // this.updateProductInfo(selectedOptionId, selectedOptionPrice, selectedOptionAvailable)

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct  // true / false
          // callback: true  // true / false
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      updateProductInfo(variantId, variantPrice, variantAvailable){
        const buyButton = this.querySelector(`.js-add-to-cart .product-variant-id`);
        // html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,

        buyButton.value = variantId;

        // const variant = this.getSelectedVariant(html);

          //PM
          // this.pickupAvailability?.update(variant);
          // this.updateOptionValues(html);
          // this.updateURL(productUrl, variant?.id);
          // this.updateVariantInputs(variant?.id);

          // PM
          // if (!variantId) {
          //   this.setUnavailable();
          //   return;
          // }

          //this.updateMedia(html, variant?.featured_media?.id);

          // const hideQuickView = () => {
          //   let quick = this.querySelector('.product-card__quick-add');
          //   let buyButton = this.querySelector('.js-add-to-cart');
          //   quick.classList.add('hidden');
          //   buyButton.classList.remove('hidden');
          // }

          // hideQuickView();

          const updatePrice = () => {
            // document.getElementById('additional-price').innerText = theme.Currency.formatMoney(variant.price);
            // Shopify.formatMoney(cart.total_price).replace('$', 'currencySymbol');
            // this.querySelectorAll('.price-item--regular').innerText = Shopify.formatMoney(variant.price);
            let formatedRegularPrice = Shopify.formatMoney(variantPrice);
            let regularPrices = this.querySelectorAll('[data-price-regular]');
            regularPrices.forEach(function(item){
              item.innerText = Shopify.formatMoney(variantPrice);
            });
            
            // if(variant.compare_at_price){
            //   let compareAtPrices = this.querySelectorAll('[data-compare-price]');
            //   compareAtPrices.forEach(function(item){
            //     item.innerText = Shopify.formatMoney(variant.compare_at_price);
            //     item.classList.remove('hidden');
            //   });
            // } else {
            //   let compareAtPrices = this.querySelectorAll('[data-compare-price]');
            //   compareAtPrices.forEach(function(item){
            //     item.classList.add('hidden');
            //   });
            // }
          }

          updatePrice();


          this.productForm?.toggleSubmitButton( !variantAvailable ?? true, window.variantStrings.soldOut);

          // publish(PUB_SUB_EVENTS.variantChange, {
          //   data: {
          //     sectionId: this.sectionId,
          //     html,
          //     variant,
          //   },
          // });
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          // const selector = updateFullPage ? "product-card-information[id^='CardProduct']" : 'product-card-information';
          const selector = `#${this.id}`;
          const variant = this.getSelectedVariant(html.querySelector(selector));
          //this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector(`#${this.id}`),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }




      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(`#${this.id} variant-selects [data-selected-variant]`)?.innerHTML;
        console.log(productInfoNode);
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }


      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) { // OK
        const variantSelects = html.querySelector(`#${this.id} variant-selects`);

        if (variantSelects) {
            // console.log(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks)
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      updateMedia(html, variant) {
        const variantSelects = html.querySelector(`#${this.id} variant-selects [data-selected-variant]`);//get object of featured images of variants
        const jsonString = variantSelects.innerHTML;
        const jsonObject = JSON.parse(jsonString);
        let variantID = jsonObject.id;

        const cardProduct = html.querySelector(`#${this.id} variant-selects [data-selected-variant]`); //try get images from metafields of variant
        let fullInfo = cardProduct.closest('.card-wrapper');
        let fullInfoHTML = fullInfo.querySelector('[data-product-notfull-info]');
        const fullInfoJson = fullInfoHTML?.innerHTML;
        const fullInfoObject = JSON.parse(JSON.parse(fullInfoJson));
        let newImage = fullInfoObject[variantID];
        
        if ( ! newImage && variantSelects ) { // if metafields variant images does not exists
          const jsonString = variantSelects.innerHTML;
          const jsonObject = JSON.parse(jsonString);
          if ( ! jsonObject.featured_image ) return false;
          newImage = jsonObject.featured_image.src
        } 

        const container = document.querySelector(`#${this.id}`).closest('.product-card-wrapper');
        const imageFeatured = container.querySelector('.card__media .media img:first-child');
        imageFeatured?.setAttribute('src', newImage);
        imageFeatured?.setAttribute('srcset', '');
        container.querySelector('.card__media .media img:nth-child(2)')?.remove();
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          //PM
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          // this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          // PM
          if (!variant || variant.available == false) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant);

          const updatePrice = () => {
            // document.getElementById('additional-price').innerText = theme.Currency.formatMoney(variant.price);
            // Shopify.formatMoney(cart.total_price).replace('$', 'currencySymbol');
            // this.querySelectorAll('.price-item--regular').innerText = Shopify.formatMoney(variant.price);
            let formatedRegularPrice = Shopify.formatMoney(variant.price);
            let regularPrices = this.querySelectorAll('[data-price-regular]');
            regularPrices.forEach(function(item){
              item.innerText = Shopify.formatMoney(variant.price);
            });
            
            if(variant.compare_at_price){
              let compareAtPrices = this.querySelectorAll('[data-compare-price]');
              compareAtPrices.forEach(function(item){
                item.innerText = Shopify.formatMoney(variant.compare_at_price);
                item.classList.remove('hidden');
              });
            } else {
              let compareAtPrices = this.querySelectorAll('[data-compare-price]');
              compareAtPrices.forEach(function(item){
                item.classList.add('hidden');
              });
            }
          }

          updatePrice();

          // const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
          //   // const source = html.getElementById(`#${this.id} ${id}-${this.sectionId}`);
          //   const source = html.querySelector(`#${this.id} #${id}-${this.sectionId}`);
          //   const destination = this.querySelector(`#${id}-${this.dataset.section}`);
          //   if (source && destination) {
          //     destination.innerHTML = source.innerHTML;
          //     destination.classList.toggle('hidden', shouldHide(source));
          //   }
          // };

          // updateSourceFromDestination('price');
          //updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          // updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          // updateSourceFromDestination('Volume');
          // updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          // this.updateQuantityRules(this.sectionId, html);
          // this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          // this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }


      updateVariantInputs(variantId) { // buy button change Id  OK
        // #card-product-form-template--17396615020722__featured_collection_4Xmy7f8261992120498
        this.querySelectorAll(
          `#${this.id} #card-product-form-${this.dataset.section}${this.dataset.productId}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');

          // console.log(88, input)
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        // this.querySelector('share-button')?.updateUrl(
        //   `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        // );

        // if (this.dataset.updateUrl === 'false') return;
        // window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }


      get productForm() {
        return this.querySelector(`product-form`);
      }

      get pickupAvailability() { 
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector(`#${this.id} variant-selects`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
